import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-caste-form',
  templateUrl: './caste-form.component.html',
  styleUrls: ['./caste-form.component.css']
})
export class CasteFormComponent implements OnInit {

  title = "Add Caste";
  data: any = {};
  formInvalid: boolean = false;
  c: any = {};
  r: any = {};
  rev: any = {};
  mode: any;
  Caste_Id: any;
  // caste_code:any;
  religionList: any
  CasteCategoryList: any
  Code: any;
  castelist: any =[];
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private titlecasePipe:TitleCasePipe) {

  }
  // this.route.params.subscribe(params => {      
  //   this.Rlg_Id = params['Rlg_Id'];  
  //   this.mode  =  params['mode'];   

  //     if(this.Rlg_Id > 0){
  //       this.GetReligionById(this.Rlg_Id)
  //     }    

  ngOnInit() {

    this.getReligions()

    this.route.params.subscribe(params => {
      this.Caste_Id = params['Caste_Id'];
      this.mode = params['mode'];

      if (this.Caste_Id > 0) {

        this.GetCasteById(this.Caste_Id)
      }
    });
    if (this.mode == 'View') {
      this.title = "View Caste ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit Caste ";
    }

    this.GetCasteCategory();
  }
  getReligions() {
    debugger;
    this.data = this.userService.Getreligions();
    this.data.subscribe(
      (response) => {
        this.religionList = response.ReligionModel;
      })


    this.data = this.userService.GetAllCodes('caste_mst');
    this.data.subscribe(
      (response: any) => {
        this.Code = response;
        if ((this.mode != 'View') && (this.mode != 'Edit')) {
          this.c.caste_code = response;
        }

      })
  }

  GetCasteCategory() {
    debugger;
    this.data = this.userService.GetCategory();
    this.data.subscribe(
      (response) => {
        this.CasteCategoryList = response.Caste_Category;

      })

    this.data = this.userService.GetAllCasteCodes();
    this.data.subscribe(
      (response: any) => {
        this.castelist = response;
      })

  }


  //       SaveCaste(Caste: NgForm)
  //       { 
  //         debugger;

  //         console.log(Caste.value);

  //         if(Caste.invalid)
  //         {
  //           // this.formInvalid = true;
  //           // swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
  //           // return;
  //         }     
  //         else{   
  //                //Caste.value.Rlg_Id_FK= this.r.Rlg_Id;                   
  //                 this.data = this.userService.PostCaste(Caste.value);    
  //                 this.data.subscribe(
  //                 (response) => {
  //                   Caste.reset();
  //                   Caste.resetForm();
  //                   Caste.form.markAsPristine();
  //                   Caste.form.markAsUntouched();        
  //                   // swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
  //                   this.router.navigate(['/CasteMasterCreationGrid/']) ;   
  //                   document.getElementById('loader-spinner').style.display = "none";           
  //                 }, (error) => {
  //                   document.getElementById('loader-spinner').style.display = "none";
  //                   if (error.status == 401) {
  //                     this.errorHandler.HandlerError(error);
  //                   }
  //                   else if (error.status == 400) {
  //                     swal('Warning!', error.error.Message, 'warning');
  //                 }
  //             });  
  //     } 
  // }


  SaveCaste(Caste: NgForm) {
    debugger;  

    Caste.value.caste_name = this.titlecasePipe.transform(Caste.value.caste_name);
    
    var list = this.castelist.filter(a => a.caste_name == Caste.value.caste_name);
   if(list.length>0){
    swal('Warning!', Caste.value.caste_name+' already exist.', 'warning');
    return;
   }

    //Caste.value.caste_code = this.Code;
    if (Caste.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    else {
      //Caste.value.Rlg_Id_FK= this.r.Rlg_Id;                   
      this.data = this.userService.PostCaste(Caste.value);
      this.data.subscribe(
        (response) => {
          Caste.reset();
          Caste.resetForm();
          Caste.form.markAsPristine();
          Caste.form.markAsUntouched();
          swal('Success!', 'Caste Added Successfully .', 'success');
          this.router.navigate(['/home/masters/caste']);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
  }
  GetCasteById(Caste_Id) {
    debugger;
    
    //document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetCasteById(Caste_Id);
    this.data.subscribe(
      (response: any) => {
        this.c = response;

        //document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //document.getElementById('loader-spinner').style.display = "none";
      });
  }

  UpdateCasteDetails(Caste: NgForm) {

 if (Caste.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }

    debugger;
    Caste.value.caste_code = this.Code;
    this.data = this.userService.UpdateCasteDetails(this.Caste_Id, Caste.value);
    this.data.subscribe(
      (response) => {
        swal('Success!', ' Caste details updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        this.router.navigate(['/home/masters/caste']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.HandlerError(error);
        }

      });
  }
  Cancel() {
    this.c.Rlg_Id = '';
    this.c.caste_code = '';
    this.c.caste_name = '';
    this.c.fix_code_id = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/master/caste/caste-form/caste-form.component.ts